import { NextPage } from "next";
import Head from "next/head";
import { TextBlockWithTitle } from "../components/TextBlockWithTitle";
import { PageLayout, PageTypes } from "../layouts/page";
import { Text } from "./terms-of-service";

const CopyrightNotice: NextPage = () => {
  return (
    <>
      <Head>
        <title>Copyright Notice</title>
      </Head>
      <PageLayout showAccents pageType={PageTypes.NARROW}>
        <TextBlockWithTitle title={"Copyright Notice"}>
          <Text>
            VAULT transmits material sent to and from its customers, and does
            not exercise any control over the contents its customers share.
            VAULT does not, and cannot, modify or alter the content it
            transmits. VAULT respects the intellectual property rights of others
            and requires those that use our services. We may, in appropriate
            circumstances and at our discretion, remove, or disable access to
            material streamed through VAULT’s service that infringes upon the
            copyright rights of others. We also may, at our discretion, remove
            or disable accounts that are providing infringing material or are
            engaged in infringing activity. In the event that any users of our
            services repeatedly infringe on others’ copyrights, we may in our
            sole discretion terminate those individuals’ rights to use our
            services. If you believe that your content has been used or
            displayed on our service in any manner that constitutes copyright
            infringement, please notify VAULT’s copyright agent by written
            notice. <br />
            <br />
            The notice should include the following information:
            <br />
            <ul>
              <li>
                An electronic or physical signature of a person authorized to
                act on behalf of the owner of the copyright allegedly infringed;
              </li>
              <li>
                A description of the copyrighted work you claim has been
                infringed, including a copy of the copyrighted work or the web
                page address where the copyrighted work may
                be&nbsp;found;Identification of the location of the material you
                claim has been infringed, or the link or reference to another
                website that contains the material you claim has been infringed;
              </li>
              <li>Your name, address, telephone number and email address;</li>
              <li>
                A statement by you that you have a good faith belief that the
                disputed use of the material at issue is not authorized by the
                copyright owner, the agent of the copyright owner or the law;
                and
              </li>
              <li>
                A statement by you that the information in this notification is
                accurate and a statement, under penalty of perjury, that you are
                the copyright owner of the material allegedly infringed or
                authorized to act on the copyright owner's behalf.
              </li>
            </ul>
            <br />
            Notices which meet all of these requirements will be considered
            “DMCA Notices” for purposes of VAULT’s repeat infringer
            policy.&nbsp; VAULT’s copyright agent for notice of claims of
            copyright infringement can be reached at the following:
            <br />
            <br />
            Copyright AgentVAULT, Inc.100 Mamaroneck AveMamaroneck, New York
            10543
            <br />
            Email: support@vault.fan&nbsp;
            <br />
            <br />
            Repeat Infringer Policy&nbsp;VAULT reserves the right to remove or
            disable access to material on our service that infringes upon the
            copyright rights of others.&nbsp; VAULT will, in appropriate
            circumstances and at our discretion, terminate a user’s account if
            it is determined the user is a repeat infringer. A repeat infringer
            is a user for whom VAULT has received more than three (3) DMCA
            notifications.&nbsp; VAULT, however, reserves the right in its sole
            discretion to terminate a user at any time for copyright
            infringement, even without receiving a DMCA notice.
            <br />
            <br />
            Upon receiving a DMCA notice, VAULT will provide a copy of the
            notice to the affected user.&nbsp; If the affected user provides
            VAULT with a counter-notice that complies with this policy in
            response to the DMCA notice and the copyright owner providing the
            DMCA notice does not answer or during the course of legal
            proceedings a court finds that the VAULT user has not infringed a
            copyright, the DMCA notice will not count as a notification for
            purposes of VAULT’s repeat infringer policy.&nbsp; Likewise, if the
            copyright owner retracts his or her notice, it will not count as a
            DMCA notification under this policy.
          </Text>
        </TextBlockWithTitle>
      </PageLayout>
    </>
  );
};

export default CopyrightNotice;
